import type { IconSvgObject } from './types';

const Notebook02Icon: IconSvgObject = [
  ["path", { d: "M8 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 6H3M5 12H3M5 18H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 7H13M15 11H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M9 21L9 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Notebook02Icon;
